<div class="flex flex-row justify-between items-center">
  <h2>
    {{ '+ACTIVE_ERROR_DETAILS_PAGE.LIVE_VDD.HEADER' | translate }}
  </h2>

  <button
    mat-raised-button
    color="primary"
    gtm="onStart"
    gtmAction="Retry otx vdds read"
    gtmCategory="guidedTroubleshootingPage"
    [disabled]="diagStackOtxStore.isAnyFromOtxVddListLoading$ | async"
    *ngIf="!(diagStackOtxStore.isOtxVddSequenceLoading$ | async)"
    (click)="retryVddRead()"
  >
    <span>{{ 'GENERAL.BUTTON.REFRESH' | translate }}</span>
    <mat-spinner
      *ngIf="diagStackOtxStore.isAnyFromOtxVddListLoading$ | async; else refreshValues"
    ></mat-spinner>
    <ng-template #refreshValues>
      <mat-icon>refresh</mat-icon>
    </ng-template>
  </button>
</div>

<mat-spinner
  *ngIf="diagStackOtxStore.isOtxVddSequenceLoading$ | async; else showData"
></mat-spinner>

<ng-template #showData>
  <div class="container">
    <ng-container
      *ngIf="diagStackOtxStore.getFlattenedListOfVddFromOtxSequenceResult$ | async as listOfVdd"
    >
      <ng-container *ngFor="let vddName of listOfVdd">
        <app-show-live-vdd-table-item [vddName]="vddName"></app-show-live-vdd-table-item>
      </ng-container>
      <div class="no-data-container" *ngIf="!listOfVdd?.length">
        {{ 'GENERAL.NO_DATA' | translate }}
      </div>
    </ng-container>
  </div>
</ng-template>
